import { render, staticRenderFns } from "./LeaveRequestForm.vue?vue&type=template&id=1315e822&"
import script from "./LeaveRequestForm.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports